export default "__VITE_ASSET__DDwT5J2e__"